import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900 flex flex-col" data-id="element-407">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-4 sticky top-0 bg-white/90 backdrop-blur-sm z-10" data-id="element-408">
        <div className="max-w-3xl mx-auto flex items-center justify-between" data-id="element-409">
          <a href="#" className="flex items-center gap-2 text-sm text-gray-500 hover:text-rose-600 transition-colors" data-id="element-410">
            <ArrowLeft className="h-4 w-4" data-id="element-411" />
            Volver al inicio
          </a>
          <span className="font-bold text-gray-900" data-id="element-412">
            Di Esto, <span className="text-rose-600" data-id="element-413">No Aquello™</span>
          </span>
        </div>
      </header>

      <main className="flex-grow px-4 py-12" data-id="element-414">
        <div className="max-w-3xl mx-auto prose prose-rose prose-headings:font-bold prose-a:text-rose-600" data-id="element-415">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-416">
            Política de Privacidad
          </h1>
          <p className="text-sm text-gray-500 mb-8" data-id="element-417">
            Última actualización: Febrero 2026
          </p>

          <h3 data-id="element-418">1. Información que Recopilamos</h3>
          <p data-id="element-419">
            Respetamos tu privacidad y nos comprometemos a proteger tus datos
            personales. Cuando visitas nuestro sitio o realizas una compra,
            podemos recopilar la siguiente información:
          </p>
          <ul data-id="element-420">
            <li data-id="element-421">
              <strong data-id="element-422">Información personal:</strong> Nombre, dirección de correo
              electrónico y número de teléfono (proporcionados al realizar la
              compra).
            </li>
            <li data-id="element-423">
              <strong data-id="element-424">Información de pago:</strong> Procesada de forma segura
              por Hotmart (no almacenamos tus datos financieros).
            </li>
            <li data-id="element-425">
              <strong data-id="element-426">Datos de uso:</strong> Información sobre cómo interactúas
              con nuestro sitio web (mediante cookies y tecnologías similares).
            </li>
          </ul>

          <h3 data-id="element-427">2. Uso de la Información</h3>
          <p data-id="element-428">Utilizamos tu información para:</p>
          <ul data-id="element-429">
            <li data-id="element-430">Procesar tu pedido y entregar el producto digital.</li>
            <li data-id="element-431">
              Enviarte correos electrónicos relacionados con tu compra
              (confirmación, acceso, actualizaciones).
            </li>
            <li data-id="element-432">Responder a tus consultas de soporte.</li>
            <li data-id="element-433">Mejorar nuestro sitio web y servicios.</li>
            <li data-id="element-434">Cumplir con obligaciones legales.</li>
          </ul>

          <h3 data-id="element-435">3. Hotmart como Procesador de Pagos</h3>
          <p data-id="element-436">
            Utilizamos la plataforma <strong data-id="element-437">Hotmart</strong> para procesar
            todos los pagos y entregar el producto digital. Hotmart tiene su
            propia política de privacidad y medidas de seguridad para proteger
            tus datos financieros. Al comprar, tus datos son compartidos con
            Hotmart para completar la transacción.
          </p>

          <h3 data-id="element-438">4. Cookies y Tecnologías de Rastreo</h3>
          <p data-id="element-439">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio.
            También podemos utilizar píxeles de terceros (como el Meta Pixel)
            para medir la efectividad de nuestra publicidad y mostrar anuncios
            relevantes. Puedes configurar tu navegador para rechazar cookies,
            aunque esto podría afectar algunas funcionalidades del sitio.
          </p>

          <h3 data-id="element-440">5. Compartir Información con Terceros</h3>
          <p data-id="element-441">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros para fines comerciales, excepto con proveedores de
            servicios necesarios para nuestra operación (como Hotmart para pagos
            o servicios de email marketing para enviarte el producto).
          </p>

          <h3 data-id="element-442">6. Seguridad de los Datos</h3>
          <p data-id="element-443">
            Implementamos medidas de seguridad razonables para proteger tu
            información personal contra acceso no autorizado, alteración o
            divulgación. Sin embargo, ninguna transmisión por internet es 100%
            segura.
          </p>

          <h3 data-id="element-444">7. Tus Derechos</h3>
          <p data-id="element-445">
            Tienes derecho a acceder, corregir o eliminar tu información
            personal que tenemos almacenada. Para ejercer estos derechos,
            contáctanos a nuestro correo electrónico.
          </p>

          <h3 data-id="element-446">8. Cambios a esta Política</h3>
          <p data-id="element-447">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos publicando la nueva
            política en esta página.
          </p>

          <h3 data-id="element-448">9. Contacto</h3>
          <p data-id="element-449">
            Si tienes preguntas sobre nuestra política de privacidad,
            contáctanos en:{' '}
            <a href="mailto:amorconprincipios.info@gmail.com" data-id="element-450">
              amorconprincipios.info@gmail.com
            </a>
            .
          </p>
        </div>
      </main>

      <Footer data-id="element-451" />
    </div>;
}